/**
 * Sticky product form that appears on scroll
 * Shows a sticky add-to-cart bar at the bottom when user scrolls past product details
 */

export class StickyProductForm extends HTMLElement {
  static TRANSITION = 'transform 0.3s ease'
  static UI_VISIBLE_SELECTOR = '[data-ui~="visible"]'
  static get UI_THRESHOLD() {
    const productMain = document.querySelector('.product-main')
    return productMain ? productMain.getBoundingClientRect().height / 4 * 3 : window.innerHeight * 1.3
  }

  lastScrollY: number
  ticking: boolean
  isVisible: boolean
  isScrolled: boolean
  bottomOffset: number
  elementHeight: number
  stickyFormElement: HTMLElement | null

  constructor() {
    super()

    // State variables
    this.lastScrollY = window.scrollY
    this.ticking = false
    this.isVisible = false
    this.isScrolled = false

    this.style.transition = StickyProductForm.TRANSITION
    this.bottomOffset = parseInt(window.getComputedStyle(this).bottom.replace('px', ''))
    this.stickyFormElement = this.querySelector('#sticky-product-form')
    this.elementHeight = this.stickyFormElement ? this.stickyFormElement.getBoundingClientRect().height : this.getBoundingClientRect().height

    // Bind scroll handler
    this.handleScroll = this.handleScroll.bind(this)
  }

  get hiddenPosition() {
    return 'translateY(100%)'
  }

  get visiblePosition() {
    return 'translateY(-100%)'
  }

  connectedCallback() {
    this.bottomOffset = parseInt(window.getComputedStyle(this).bottom.replace('px', ''))
    this.stickyFormElement = this.querySelector('#sticky-product-form')
    this.elementHeight = this.stickyFormElement ? this.stickyFormElement.getBoundingClientRect().height : this.getBoundingClientRect().height

    window.addEventListener('scroll', this.handleScroll, { passive: true })

    // Start hidden
    this.style.transform = this.hiddenPosition
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  showStickyForm() {
    if (!this.isVisible) {
      this.style.transform = this.visiblePosition
      this.isVisible = true
      this.setAttribute('data-visible', 'visible')
    }
  }

  hideStickyForm() {
    if (this.isVisible) {
      this.style.transform = this.hiddenPosition
      this.isVisible = false
      this.removeAttribute('data-visible')
    }
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        const currentScroll = window.scrollY

        // Show sticky bar if we're past the threshold
        if (currentScroll > StickyProductForm.UI_THRESHOLD) {
          this.showStickyForm()
        } else {
          this.hideStickyForm()
        }
        this.lastScrollY = currentScroll
        this.ticking = false
      })

      this.ticking = true
    }
  }
}
